// extracted by mini-css-extract-plugin
export default {"unauth":"PersonalPage_unauth__1gI68","btns":"PersonalPage_btns__jMWV8","btn":"PersonalPage_btn__iqI1a","img":"PersonalPage_img__-F7JS"};